import React, { useEffect, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useImmer } from 'use-immer'
import ConfidenceSelect from 'assets/confidence_select.svg'
import ConfidenceUnselect from 'assets/confidence_unselect.svg'

import {
    getIssuesList,
    getIssuesStats,
    filterIssues,
} from 'store/issues/actions'
import Image from 'components/common/ImageLoader'
import Button from 'components/common/Button'
import SearchIcon from 'assets/search_icon_old.svg'
import { useMediaQueryUtils } from 'constants/exportHooks'

const queryString = require('query-string')

const FilterIssues = ({ updateFilterQueryParams }) => {
    const queryParams = queryString.parse(window.location.search)
    const dispatch = useDispatch()
    const issueStore = useSelector((state) => state.issues)
    const stats = issueStore?.stats?.data
    const [state, setState] = useImmer({
        filterQueryParams: {},
    })

    const { isDesktop, isMobile, isTablet } = useMediaQueryUtils()
    const searchInputRef = useRef('')

    const defaultSortParams = `added&reverse=true`
    const sortQueryParams =
        queryParams?.sort !== '' ? queryParams?.sort : defaultSortParams

    const { filterQueryParams } = state

    const severityLabels = {
        1: 'Critical',
        2: 'High',
        3: 'Medium',
        4: 'Low',
        5: 'Information',
    }

    const executeDefaultQuery = () => {
        const queryParams = queryString.parse(window.location.search)
        dispatch(
            getIssuesList(
                queryParams?.sort
                    ? `?sort=${queryParams?.sort}${
                          queryParams.reverse
                              ? `&reverse=${queryParams.reverse}`
                              : ''
                      }`
                    : '?sort=added&reverse=true'
            )
        )
    }

    const executeQuery = () => {
        let str = ''
        const searchInputValue = searchInputRef.current.value

        if (sortQueryParams) {
            str = str + `?sort=${sortQueryParams}`
        }

        if (Object.keys(filterQueryParams).length > 0) {
            if (str !== '') {
                str =
                    str +
                    `&filter_values=${filterQueryParams.value}&filter_fields=${filterQueryParams.field}`
            } else {
                str = `?filter_values=${filterQueryParams.value}&filter_fields=${filterQueryParams.field}`
            }
        }
        if (searchInputValue) {
            str += `${str ? '&' : '?'}search=${searchInputValue}`
        }

        dispatch(filterIssues(str))
    }

    useEffect(() => {
        if (Object.keys(filterQueryParams).length > 0) {
            // updateFilterQueryParams(
            //     filterQueryParams.field,
            //     filterQueryParams.value
            // )
            executeQuery()
        }
    }, [filterQueryParams])

    const onClickFilter = (field, value) => {
        const queryParams = queryString.parse(window.location.search)

        if (
            Object.keys(filterQueryParams).length > 0 &&
            filterQueryParams?.field === field &&
            filterQueryParams?.value === value
        ) {
            // flush out filter params from window URL
            console.log('flush out filter params')
            window.history.pushState(
                {},
                document.title,
                queryParams?.sort
                    ? `/?sort=${queryParams?.sort}`
                    : '/?sort=added&reverse=true'
            )
            setState((draft) => {
                draft.filterQueryParams = {}
            })

            executeDefaultQuery()
        } else {
            // update window URL with filter params
            window.history.pushState(
                {},
                document.title,
                queryParams?.sort
                    ? `?sort=${queryParams?.sort}&filter_fields=${field}&filter_values=${value}`
                    : `?filter_fields=${field}&filter_values=${value}`
            )
            setState((draft) => {
                draft.filterQueryParams = {
                    field,
                    value,
                }
            })
        }
    }

    const clearFilter = () => {
        searchInputRef.current.value = ''
        setState((draft) => {
            draft.filterQueryParams = {}
        })
        executeDefaultQuery()
        window.history.pushState(
            {},
            document.title,
            '/?sort=added&reverse=true'
        )
        // updateFilterQueryParams()
    }

    return (
        <React.Fragment>
            <div className="h-full">
                <div className="flex justify-between items-center ">
                    <div className=" text-lg-label font-bold">Filters</div>
                    <a
                        className="p-v-1 px-2 bg-negative-red-100 text-md-label rounded-md text-negative-red-600 font-semibold"
                        href=""
                        onClick={(e) => {
                            e.preventDefault()
                            clearFilter()
                        }}
                    >
                        Clear
                    </a>
                </div>

                <div className="w-full py-2 flex items-center">
                    <div
                        id="search-fingerprint-box"
                        className="py-2 relative flex flex-wrap items-center w-full"
                    >
                        <input
                            className="px-4 text-sm pr-10 py-2 rounded-sm sm:w-11/12 border border-gray-300 focus:outline-none  "
                            type="text"
                            placeholder="Search "
                            ref={searchInputRef}
                            onKeyUp={(e) => {
                                if (e.keyCode == 13) {
                                    executeQuery()
                                }
                            }}
                        />

                        <div className="sm:-ml-10 xl:-ml-12">
                            <Image
                                addClass=""
                                src={SearchIcon}
                                width={isTablet || isMobile ? '25' : '35'}
                                height={isTablet || isMobile ? '25' : '35'}
                            />
                        </div>
                    </div>
                    <div className="py-2 ml-2">
                        <Button
                            customClass="px-3 py-1 rounded bg-primary-purple-500 text-sm"
                            onClick={executeQuery}
                        >
                            Search
                        </Button>
                    </div>
                </div>

                <div className=" mt-6 ">
                    <div className=" text-sm-label font-bold text-neutral-gray-150">
                        Severity
                    </div>
                    <div className=" mt-2">
                        {stats?.counts_by_severity &&
                            Object.keys(stats?.counts_by_severity).map(
                                (item, index) => (
                                    <React.Fragment key={index}>
                                        {filterQueryParams.value === item ? (
                                            <div
                                                className="w-full flex flex-wrap justify-between 
                                                py-1 pl-2 pr-1 mb-2 cursor-pointer 
                                                text-neutral-gray-500 bg-primary-purple-100 border border-primary-purple-300 rounded"
                                                onClick={(e) => {
                                                    e.stopPropagation()
                                                    onClickFilter(
                                                        'severity',
                                                        item
                                                    )
                                                }}
                                            >
                                                <div className="flex items-center">
                                                    <div
                                                        className={`w-2 h-2  rounded-sm bg-severity-${item}`}
                                                    ></div>
                                                    <div className="pl-2 text-sm-label font-semibold text-neutral-gray-500">
                                                        {severityLabels[item]}
                                                    </div>
                                                </div>
                                                <div className=" bg-neutral-gray-100 rounded text-sm-label font-semibold text-neutral-gray-600 p-1">
                                                    {
                                                        stats
                                                            .counts_by_severity[
                                                            item
                                                        ]
                                                    }
                                                </div>
                                            </div>
                                        ) : (
                                            <div
                                                className="w-full flex flex-wrap justify-between 
                                                py-1 pl-2 pr-1 mb-2 bg-white cursor-pointer hover:bg-primary-purple-100
                                                border border-neutral-gray-200 rounded"
                                                onClick={(e) => {
                                                    e.stopPropagation()
                                                    onClickFilter(
                                                        'severity',
                                                        item
                                                    )
                                                }}
                                            >
                                                <div className="flex items-center">
                                                    <div
                                                        className={`w-2 h-2  rounded-sm bg-severity-${item}`}
                                                    ></div>
                                                    <div className="pl-2 text-sm-label font-semibold text-neutral-gray-500">
                                                        {severityLabels[item]}
                                                    </div>
                                                </div>
                                                <div className=" bg-neutral-gray-100 rounded text-sm-label font-semibold text-neutral-gray-600 p-1">
                                                    {
                                                        stats
                                                            .counts_by_severity[
                                                            item
                                                        ]
                                                    }
                                                </div>
                                            </div>
                                        )}

                                        {/* <div className="w-1/12 ">
                                                {filterQueryParams.value ===
                                                item ? (
                                                    <a
                                                        href=""
                                                        onClick={(e) => {
                                                            e.preventDefault()
                                                            onClickFilter(
                                                                'severity',
                                                                item
                                                            )
                                                        }}
                                                    >
                                                        <img
                                                            className="h-full m-auto"
                                                            alt="empty-checkbox"
                                                            width={15}
                                                            height={15}
                                                            src={CheckboxSVG}
                                                        />
                                                    </a>
                                                ) : (
                                                    <a
                                                        href=""
                                                        onClick={(e) => {
                                                            e.preventDefault()
                                                            onClickFilter(
                                                                'severity',
                                                                item
                                                            )
                                                        }}
                                                    >
                                                        <img
                                                            className="h-full m-auto"
                                                            alt="checkbox"
                                                            width={15}
                                                            height={15}
                                                            src={
                                                                EmptyCheckboxSVG
                                                            }
                                                        />
                                                    </a>
                                                )}
                                            </div> */}
                                        {/* <div className="w-11/12 pl-2 text-sm">
                                                {item}
                                                <span class="pl-1 text-sm ">
                                                    (
                                                    {
                                                        stats
                                                            .counts_by_severity[
                                                            item
                                                        ]
                                                    }
                                                    )
                                                </span>
                                            </div> */}
                                    </React.Fragment>
                                )
                            )}
                    </div>
                </div>

                <div className="mt-6">
                    <div className=" text-sm-label font-bold text-neutral-gray-150">
                        Status
                    </div>
                    <div className="mt-2">
                        {stats?.counts_by_status &&
                            Object.keys(stats?.counts_by_status).map(
                                (item, index) => (
                                    <React.Fragment key={index}>
                                        <div
                                            className="w-full flex flex-wrap justify-between 
                                        py-1 pl-2 pr-1 mb-2 bg-white hover:bg-primary-purple-100 cursor-pointer 
                                        border border-neutral-gray-200 rounded"
                                            onClick={(e) => {
                                                e.stopPropagation()
                                                onClickFilter('status', item)
                                            }}
                                        >
                                            <div className="flex items-center">
                                                {filterQueryParams.value ===
                                                item ? (
                                                    <a href="">
                                                        <img
                                                            className="h-full m-auto"
                                                            alt="checkbox"
                                                            width={16}
                                                            height={16}
                                                            src={
                                                                ConfidenceSelect
                                                            }
                                                        />
                                                    </a>
                                                ) : (
                                                    <a href="">
                                                        <img
                                                            className="h-full m-auto"
                                                            alt="checkbox"
                                                            width={15}
                                                            height={15}
                                                            src={
                                                                ConfidenceUnselect
                                                            }
                                                        />
                                                    </a>
                                                )}
                                                <div className="pl-2 text-sm-label font-semibold text-neutral-gray-500">
                                                    {item}
                                                </div>
                                            </div>
                                            <div className=" bg-neutral-gray-100 rounded text-sm-label font-semibold text-neutral-gray-600 p-1">
                                                {stats.counts_by_status[item]}
                                            </div>
                                        </div>
                                    </React.Fragment>
                                )
                            )}
                    </div>
                </div>

                <div className="mt-6">
                    <div className=" text-sm-label font-bold text-neutral-gray-150">
                        Category
                    </div>
                    <div className="mt-2">
                        {stats?.counts_by_category &&
                            Object.keys(stats?.counts_by_category)
                                .reverse()
                                .map((item, index) => (
                                    <React.Fragment key={index}>
                                        <div
                                            className="w-full flex flex-wrap justify-between 
                                        py-1 pl-2 pr-1 mb-2 bg-white hover:bg-primary-purple-100 cursor-pointer  
                                        border border-neutral-gray-200 rounded"
                                            onClick={(e) => {
                                                e.stopPropagation()
                                                onClickFilter('category', item)
                                            }}
                                        >
                                            <div className="flex items-center">
                                                <input
                                                    type="radio"
                                                    name="category"
                                                    checked={
                                                        filterQueryParams.value ===
                                                        item
                                                    }
                                                />
                                                <div className="pl-2 text-sm-label font-semibold text-neutral-gray-500">
                                                    {item}
                                                </div>
                                            </div>
                                            <div className=" bg-neutral-gray-100 rounded text-sm-label font-semibold text-neutral-gray-600 p-1">
                                                {stats.counts_by_category[item]}
                                            </div>
                                        </div>
                                    </React.Fragment>
                                ))}
                    </div>
                </div>
            </div>
        </React.Fragment>
    )
}

export default FilterIssues
